import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import NavbarModuloLF from '../../components/NavbarModuloFage';
import {
    renderField,
} from "../../Utils/renderField/renderField";

const valEmp = __CONFIG__.empresa;

function TipoDescuentoForm(props) {
    const { handleSubmit, crear, modulo } = props;

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar tipo de descuento' : 'Crear tipo de descuento';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver tipo de descuento'
    }
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div>
            {valEmp === 'fage' &&
                <NavbarModuloLF
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            {valEmp === '' &&
                <NavbarModulo
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            <form onSubmit={handleSubmit}>
                <br />
                <div className="mb-4 card card-small text-white bg-dark mb-3">
                    <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                        <div className="d-flex flex-column flex-1 mx-4">
                            <div className='row mb-2'>
                                <div className='col-6'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="descripcion"
                                        placeholder="Descripcion"
                                        className="form-control"
                                        component={renderField}
                                        disabled={disabled}
                                        msj="Descripción"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        type='submit'
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                {valEmp === 'fage' &&
                                    <a
                                        href={`/#/lfg/nomina/${id_emp[6]}/tipo_descuento`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                                {valEmp === '' &&
                                    <a
                                        href={`/#/nomina/${id_emp[5]}/tipo_descuento`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form >
        </div >
    );
}

TipoDescuentoForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormTipoDescuentoNomina',
    validate: (data) => {
        return validate(data, {
            descripcion: validators.exists()('Este campo es requerido'),
        });
    },
})(TipoDescuentoForm);
